var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEvidenceIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_in_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_in_group2",
    transform: "translate(-1095.000000, -292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_in_group3",
    transform: "translate(1095.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_evidence_in_group4",
    transform: "translate(0.000000, 12.960000)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_in_polygon1",
    fill: "#000000",
    fillRule: "nonzero",
    points: "9.65647059 4.32 7.87764706 4.32 7.87764706 7.776 4.32 7.776 4.32 9.504 7.87764706 9.504 7.87764706 12.96 9.65647059 12.96 9.65647059 9.504 12.96 9.504 12.96 7.776 9.65647059 7.776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_in_polygon2",
    fill: "#000000",
    fillRule: "nonzero",
    points: "12.96 0 12.96 1.68 16.32 1.68 16.32 5.04 18 5.04 18 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_in_polygon3",
    fill: "#000000",
    fillRule: "nonzero",
    points: "0 5.04 1.764 5.04 1.764 1.68 5.04 1.68 5.04 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_in_polygon4",
    fill: "#000000",
    fillRule: "nonzero",
    points: "16.32 16.32 12.96 16.32 12.96 18 18 18 18 12.96 16.32 12.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon_evidence_in_polygon5",
    fill: "#000000",
    fillRule: "nonzero",
    points: "1.764 12.96 0 12.96 0 18 5.04 18 5.04 16.32 1.764 16.32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvidenceIn);
export default __webpack_public_path__ + "static/media/icon_evidence_in.db62dbc4.svg";
export { ForwardRef as ReactComponent };